import LayoutSidebar from "../../components/layoutSidebar/layoutSidebar";
import Browse from "../../components/browse/browse";

const Browser = () => {
  return (
    <>
      <LayoutSidebar>
        <Browse />
      </LayoutSidebar>
    </>
  )
}
export default Browser;